import api from "./ApiClient";
import qs from "qs";

const BASE_PATH_NOTIFICATIONS = '/foodz/api/v1/notificacoes';

class NotificationsService {
  static async sendEmailNotificationForOrder(clientInfo, customer, order, operator, change, products) {
    const params = { searchInput: customer.login };
    const body = { clientInfo, customer, order, operator, change, products };
    const response = await api.post(
      `${BASE_PATH_NOTIFICATIONS}/enviarComprovanteCompra`,
      body,
      { params }
    );
    return response.data;
  }

  static async sendEmailNotificationForCreditRecharge(clientInfo, customer, transactions, balanceBefore, balanceAfter, operator
  ) {
    const params = { searchInput: customer.login };

    const body = { clientInfo, customer, transactions, balanceBefore, balanceAfter, operator };

    const response = await api.post(
      `${BASE_PATH_NOTIFICATIONS}/enviarComprovanteRecarga`,
      body,
      { params }
    );

    return response.data;
  }


  static async sendEmailNotificationForOrderCancelation(student, order) {
    const params = { searchInput: student };
    const response = await api.post(
      `${BASE_PATH_NOTIFICATIONS}/notificarCancelamentoCompra`,
      order,
      { params }
    );
    return response.data;
  }

  static async sendLead(info) {
    const response = await api.post(
      `${BASE_PATH_NOTIFICATIONS}/notificarLead`,
      info
    );
    return response.data;
  }


  static async sendEmailMkt(info) {
    const response = await api.post(
      `${BASE_PATH_NOTIFICATIONS}/enviar-marketing`,
      info
    );
    return response.data;
  }


  static async sendUserCredentials(parentIds, credentials) {
    const clientCode = sessionStorage.getItem("clientCode");

    return api.post(
      `${BASE_PATH_NOTIFICATIONS}/enviarCredenciais`,
      credentials,
      {
        params: {
          parentIds,
          clientCode
        },
        paramsSerializer: params =>
          qs.stringify(params, { arrayFormat: "repeat" })
      }
    );
  }

  static async resendCredentials(logins) {
    const clientCode = sessionStorage.getItem("clientCode");
    const { data } = await api.post(`${BASE_PATH_NOTIFICATIONS}/redefinirCredenciais`, logins, {
      params: { clientCode }
    });

    return data;
  }

  static async sendBatchBilling(logins) {
    const clientCode = sessionStorage.getItem("clientCode");

    return api.post(
      `${BASE_PATH_NOTIFICATIONS}/cobrancaEmMassa`,
      logins,
      {
        params: {
          clientCode
        }
      }
    );
  }
}

export default NotificationsService;